import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function FAQ() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 px-6 bg-surface border-t border-taupe/30" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <h2 className="font-serif text-4xl mb-16 text-center" data-id="element-29">{t.faq.title}</h2>

        <div className="space-y-8" data-id="element-30">
          {t.faq.items.map((faq, index) => <div key={index} className="border-b border-taupe pb-8" data-id="element-31">
              <h3 className="text-xl font-medium text-ink mb-3" data-id="element-32">{faq.q}</h3>
              <p className="text-ink/70 leading-relaxed" data-id="element-33">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}